import React from 'react';
import { UniqueVisitor } from 'sb-lib/types';
import { useAppSelector } from 'shared/store';
import { selectRealtimeVisitor } from 'shared/store/realtime-slice';
import { Icon } from '../Icon';
import './style.less';

interface ConversationVisitorEmailReplyProps {
  visitor: UniqueVisitor;
}

export const ConversationVisitorEmailReply: React.FC<ConversationVisitorEmailReplyProps> = ({
  visitor,
}) => {
  const activeVisitor = useAppSelector(state => selectRealtimeVisitor(state, visitor.id));

  if (activeVisitor) return null;

  const email = visitor.contact?.email;

  if (!email) return null;

  return (
    <div className="ConversationVisitorEmailReply">
      <Icon icon="email" />
      Reply
      <div className="ConversationVisitorEmailReply__email">{email}</div>
    </div>
  );
};
